const getCSRF = () => {
  const cookie = document.cookie.split(/;/)
    .map(item => item.trim())
    .filter(item => item.match(/^csrftoken=/))
    .map(item => item.split(/=/, 2))[0]

  if (cookie) return cookie[1]
}

export const generateProject = async (recipe, description, generateUrl) => {
  const response = await fetch(generateUrl, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCSRF()
    },
    body: JSON.stringify({
      description
    })
  })

  if (response.status !== 200) {
    throw await response.json()
  }

  return response.json()
}

export const saveRecipe = async (recipe, saveUrl) => {
  const response = await fetch(saveUrl, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCSRF()
    },
    body: JSON.stringify(recipe)
  })

  if (response.status !== 200) {
    throw await response.json()
  }

  return response.json()
}



// WEBPACK FOOTER //
// ./src/helpers/client.js